/* Homepage behaviour: deal countdown, tabbed product rail, featured-sellers carousel dots, shopping assistant.
   Carousels themselves (peek hero, category circles, product rails) are initialised by theme.js (Theme.carousels). */
(function () {
  'use strict';
  if (window.__homeJsLoaded) return;
  window.__homeJsLoaded = true;

  var Theme = window.Theme || {};
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* ---------- countdown chip (section: product-rail) ---------- */
  var countdownTimer = null;
  function tickCountdowns() {
    var els = qsa('[data-countdown]');
    if (!els.length) { clearInterval(countdownTimer); countdownTimer = null; return; }
    var now = Math.floor(Date.now() / 1000);
    els.forEach(function (el) {
      var end = parseInt(el.getAttribute('data-end'), 10);
      if (!end || end <= now) { el.hidden = true; return; }
      var left = end - now;
      var d = Math.floor(left / 86400), h = Math.floor((left % 86400) / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
      var text = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      var out = qs('[data-countdown-text]', el);
      var prefix = el.getAttribute('data-prefix') || '';
      if (out) out.textContent = (prefix ? prefix + ' ' : '') + text;
    });
  }
  function initCountdowns() {
    if (!qs('[data-countdown]')) return;
    tickCountdowns();
    if (!countdownTimer) countdownTimer = setInterval(tickCountdowns, 1000);
  }

  /* ---------- tabbed rail (section: product-tabs) ---------- */
  function activateTab(root, tab) {
    var n = tab.getAttribute('data-tab');
    qsa('[data-tab]', root).forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
    });
    var panel = null;
    qsa('[data-tab-panel]', root).forEach(function (p) {
      var on = p.getAttribute('data-tab-panel') === n;
      p.hidden = !on;
      if (on) panel = p;
    });
    var title = qs('[data-tabs-title]', root), sub = qs('[data-tabs-sub]', root);
    if (title) title.textContent = tab.getAttribute('data-title') || '';
    if (sub) sub.textContent = tab.getAttribute('data-sub') || '';
    if (!panel) return;
    var list = qs('ul.owl-carousel', panel);
    var prev = qs('[data-tabs-prev]', root), next = qs('[data-tabs-next]', root);
    if (prev) { prev.setAttribute('data-carousel-prev', list ? '#' + list.id : ''); prev.disabled = !list; }
    if (next) { next.setAttribute('data-carousel-next', list ? '#' + list.id : ''); next.disabled = !list; }
    var cta = qs('[data-tabs-cta]', root);
    if (cta) cta.setAttribute('href', panel.getAttribute('data-view-all') || cta.getAttribute('data-fallback') || cta.getAttribute('href'));
    if (!list) return;
    if (list.hasAttribute('data-carousel-pending')) {
      /* first time shown: initialise Owl now that the panel is visible and measurable */
      list.setAttribute('data-carousel', list.getAttribute('data-carousel-pending'));
      list.removeAttribute('data-carousel-pending');
      if (Theme.carousels) Theme.carousels.init(panel);
    } else if (window.jQuery) {
      window.jQuery(list).trigger('refresh.owl.carousel');
    }
  }
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-product-tabs] [data-tab]');
    if (!tab) return;
    activateTab(tab.closest('[data-product-tabs]'), tab);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var tab = e.target.closest && e.target.closest('[data-product-tabs] [data-tab]');
    if (!tab) return;
    var tabs = qsa('[data-tab]', tab.closest('[data-product-tabs]'));
    var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    var target = tabs[(i + tabs.length) % tabs.length];
    target.focus();
    activateTab(tab.closest('[data-product-tabs]'), target);
  });

  /* ---------- featured sellers: dots + mouse drag for the scroll-snap carousel ---------- */
  function sellerMetrics(track) {
    var cards = track.querySelectorAll('.store-card');
    if (!cards.length) return null;
    var cs = window.getComputedStyle(track), padLeft = parseFloat(cs.paddingLeft) || 0;
    var step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth;
    if (!step) return null;
    var visible = Math.max(1, Math.floor((track.clientWidth - padLeft * 2 + (step - cards[0].offsetWidth) + 1) / step));
    return { cards: cards, step: step, positions: Math.max(1, cards.length - visible + 1) };
  }
  function sellerDots(track) {
    var section = track.closest('section') || document;
    return qs('.sellers-dots', section);
  }
  function syncSellers(track) {
    var dots = sellerDots(track), m = sellerMetrics(track);
    if (!dots || !m) return;
    var best = Math.round(track.scrollLeft / m.step);
    if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) best = m.positions - 1;
    best = Math.max(0, Math.min(m.positions - 1, best));
    for (var k = 0; k < dots.children.length; k++) {
      dots.children[k].classList.toggle('is-hidden', k >= m.positions);
      dots.children[k].classList.toggle('is-active', k === best);
    }
  }
  function syncAllSellers() { qsa('.sellers-carousel').forEach(syncSellers); }
  document.addEventListener('scroll', function (e) {
    if (e.target.classList && e.target.classList.contains('sellers-carousel')) syncSellers(e.target);
  }, true);
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.sellers-dots__dot');
    if (!dot) return;
    var section = dot.closest('section'), track = section && qs('.sellers-carousel', section), m = track && sellerMetrics(track);
    if (!m) return;
    var idx = Array.prototype.indexOf.call(dot.parentNode.children, dot);
    track.scrollTo({ left: idx * m.step, behavior: 'smooth' });
  });
  var drag = null, moved = false;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var track = e.target.closest && e.target.closest('.sellers-carousel');
    if (!track) return;
    drag = { track: track, x: e.clientX, left: track.scrollLeft };
    moved = false;
  });
  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (!moved && Math.abs(dx) < 5) return;
    if (!moved) { moved = true; drag.track.classList.add('is-dragging'); }
    drag.track.scrollLeft = drag.left - dx;
  });
  function endDrag() {
    if (!drag) return;
    var track = drag.track, start = drag.left, m = sellerMetrics(track);
    drag = null;
    if (!moved) return;
    track.classList.remove('is-dragging');
    if (!m) return;
    var from = Math.round(start / m.step), delta = track.scrollLeft - start;
    var to = delta > m.step * 0.15 ? from + 1 : delta < -m.step * 0.15 ? from - 1 : from;
    to = Math.max(0, Math.min(m.positions - 1, to));
    track.scrollTo({ left: to * m.step, behavior: 'smooth' });
  }
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);
  document.addEventListener('dragstart', function (e) {
    if (e.target.closest && e.target.closest('.sellers-carousel')) e.preventDefault();
  });
  document.addEventListener('click', function (e) {
    if (moved && e.target.closest && e.target.closest('.sellers-carousel')) { e.preventDefault(); e.stopPropagation(); }
    moved = false;
  }, true);
  window.addEventListener('resize', syncAllSellers);
  window.addEventListener('load', syncAllSellers);

  /* ---------- shopping assistant (section: chat-assistant) ---------- */
  var STOP = ['a', 'an', 'the', 'for', 'and', 'or', 'with', 'under', 'below', 'less', 'than', 'max', 'some', 'ideas', 'idea', 'show', 'me', 'find', 'i', 'need', 'want', 'looking', 'best', 'good', 'gift', 'gifts', 'something', 'to', 'of', 'in', 'my', 'got', 'get', 'please', 'is', 'are', 'there', 'any'];

  function initChat(root) {
    if (root.__chatReady) return;
    root.__chatReady = true;
    var panel = qs('[data-chat-panel]', root), list = qs('[data-chat-messages]', root);
    var form = qs('[data-chat-form]', root), input = qs('[data-chat-input]', root), send = qs('[data-chat-send]', root);
    var fab = qs('[data-chat-fab]', root), iconOpen = qs('[data-chat-icon-open]', root), iconClose = qs('[data-chat-icon-close]', root);
    var suggest = qs('[data-chat-suggestions]', root);
    if (!panel || !list || !form || !input || !fab) return;
    var d = root.dataset;
    var busy = false, started = false;

    function scroll() { list.scrollTop = list.scrollHeight; }
    function addMessage(from, text, extra) {
      var wrap = document.createElement('div');
      wrap.className = 'hm-msg ' + (from === 'bot' ? 'is-bot' : 'is-user');
      var bubble = document.createElement('div');
      bubble.className = 'hm-bubble ' + (from === 'bot' ? 'is-bot' : 'is-user');
      bubble.textContent = text;
      if (extra && extra.link && extra.link.href) {
        var a = document.createElement('a');
        a.href = extra.link.href;
        a.textContent = extra.link.label || extra.link.href;
        a.style.cssText = 'display:block;margin-top:6px;font-weight:600;color:#0D5C4E;text-decoration:underline';
        bubble.appendChild(a);
      }
      wrap.appendChild(bubble);
      if (extra && extra.products && extra.products.length) {
        var box = document.createElement('div');
        box.className = 'chat-products';
        extra.products.forEach(function (p) { box.appendChild(productCard(p)); });
        wrap.appendChild(box);
      }
      list.appendChild(wrap);
      scroll();
    }
    function productCard(p) {
      var a = document.createElement('a');
      a.className = 'chat-item chat-product-card';
      a.href = p.url;
      var img = p.featured_image && p.featured_image.url || p.image;
      if (img) {
        var im = document.createElement('img');
        im.className = 'chat-product-card__image';
        im.src = img;
        im.alt = '';
        im.loading = 'lazy';
        a.appendChild(im);
      }
      var info = document.createElement('span');
      info.className = 'chat-product-card__info';
      var name = document.createElement('span');
      name.className = 'chat-product-card__name';
      name.textContent = p.title;
      info.appendChild(name);
      if (p.vendor) {
        var v = document.createElement('span');
        v.className = 'text-caption';
        v.textContent = p.vendor;
        info.appendChild(v);
      }
      a.appendChild(info);
      var price = document.createElement('strong');
      price.className = 'mega-menu__product-price';
      var n = parseFloat(p.price);
      price.textContent = isNaN(n) ? '' : (Theme.money ? Theme.money(Math.round(n * 100)) : String(n));
      a.appendChild(price);
      return a;
    }
    function typing(on) {
      var el = qs('.chat-typing-bubble', list);
      if (on && !el) {
        el = document.createElement('div');
        el.className = 'chat-typing-bubble';
        el.setAttribute('aria-label', '…');
        el.innerHTML = '<span class="chat-dot"></span><span class="chat-dot chat-typing-dot-2"></span><span class="chat-dot chat-typing-dot-3"></span>';
        list.appendChild(el);
        scroll();
      } else if (!on && el) {
        el.parentNode.removeChild(el);
      }
    }
    function greet() {
      list.innerHTML = '';
      if (d.greeting) addMessage('bot', d.greeting);
      if (suggest) suggest.hidden = false;
      started = true;
    }
    function setOpen(open) {
      panel.hidden = !open;
      fab.setAttribute('aria-expanded', open ? 'true' : 'false');
      fab.setAttribute('aria-label', (open ? d.closeLabel : d.openLabel) || '');
      if (iconOpen) iconOpen.hidden = open;
      if (iconClose) iconClose.hidden = !open;
      if (open) {
        if (!started) greet();
        scroll();
        input.focus();
      } else {
        fab.focus();
      }
    }
    function parseQuery(text) {
      var t = text.toLowerCase();
      var bm = t.match(/(?:under|below|less than|max)\s*[^\d\s]?\s*(\d+(?:\.\d+)?)/) || t.match(/[$€£]\s*(\d+(?:\.\d+)?)/);
      var budget = bm ? parseFloat(bm[1]) : Infinity;
      var words = t.replace(/[^a-z0-9\s-]/g, ' ').split(/\s+/).filter(function (w) {
        return w && STOP.indexOf(w) === -1 && !/^\d+(\.\d+)?$/.test(w);
      });
      var q = words.join(' ');
      if (!q && /gift/.test(t)) q = 'gift';
      return { budget: budget, q: q, text: t };
    }
    function budgetText(budget) {
      return budget < Infinity ? ' (' + (d.currencySymbol || '') + budget + ' or less)' : '';
    }
    function reply(text) {
      var parsed = parseQuery(text);
      if (/track|order status|delivery status|where is my|where's my/.test(parsed.text)) {
        return Promise.resolve({ text: d.trackReply, link: { href: d.trackUrl, label: d.trackLabel } });
      }
      if (/return|refund/.test(parsed.text)) {
        return Promise.resolve({ text: d.returnsReply, link: { href: d.returnsUrl, label: d.returnsLabel } });
      }
      if (!parsed.q) return Promise.resolve({ text: d.none });
      var url = (Theme.routes && Theme.routes.predictiveSearch || d.searchUrl) + '.json?q=' + encodeURIComponent(parsed.q) +
        '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide';
      return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
        if (!r.ok) throw new Error('search failed');
        return r.json();
      }).then(function (json) {
        var found = (json && json.resources && json.resources.results && json.resources.results.products) || [];
        found = found.filter(function (p) { var n = parseFloat(p.price); return isNaN(n) || n <= parsed.budget; }).slice(0, 3);
        if (!found.length) return { text: d.none };
        return { text: (d.found || '').replace('{budget}', budgetText(parsed.budget)).replace('{count}', String(found.length)), products: found };
      });
    }
    function ask(text) {
      var msg = (text || '').trim();
      if (!msg || busy) return;
      busy = true;
      if (suggest) suggest.hidden = true;
      addMessage('user', msg);
      input.value = '';
      send.disabled = true;
      typing(true);
      reply(msg).then(function (r) {
        typing(false);
        addMessage('bot', r.text, r);
      }).catch(function () {
        typing(false);
        addMessage('bot', d.error);
      }).then(function () { busy = false; });
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-chat-toggle]')) { setOpen(panel.hidden); return; }
      if (e.target.closest('[data-chat-reset]')) { greet(); return; }
      var chip = e.target.closest('[data-chat-suggest]');
      if (chip) ask(chip.getAttribute('data-chat-suggest'));
    });
    input.addEventListener('input', function () { send.disabled = !input.value.trim(); });
    form.addEventListener('submit', function (e) { e.preventDefault(); ask(input.value); });
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) setOpen(false); });
  }

  function initAll(root) {
    qsa('[data-chat]', root).forEach(initChat);
    initCountdowns();
    syncAllSellers();
  }
  function ready() { initAll(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
